export default __webpack_public_path__ + "static/media/96_desktop.3c16f283.jpg";